export default "__VITE_ASSET__CMOojwP$__"